export const shadows = {
  none: 'none',
  s: '0 4px 6px 0 rgba(0, 0, 0, 0.1)', // y: 4, blur: 6, opacity: 10%
  m: '0 4px 8px 0 rgba(0, 0, 0, 0.2)', // y: 4, blur: 8, opacity: 20%
  l: '0 6px 20px 0 rgba(0, 0, 0, 0.2)', // y: 6, blur: 20, opacity: 20%
  xl: '0 15px 50px 0 rgba(0, 0, 0, 0.3)', // y: 15, blur: 50, opacity: 30%
} as const;

export type Shadows = typeof shadows;
